import { useMutation } from "@tanstack/react-query";

import type {
	ClaimV4ReleaseMessageMutation,
	ClaimV4ReleaseMessageMutationVariables,
	RecordV4ReleaseMessageEventMutation,
	RecordV4ReleaseMessageEventMutationVariables,
} from "../types/__generated/gql/graphql";
import { gqlReqNext } from "~utils/api/gql-req/next";

const claimMutation = /* GraphQL */ `
	mutation ClaimV4ReleaseMessage {
		claimV4ReleaseMessage {
			shouldShow
			seenAt
		}
	}
`;

const recordEventMutation = /* GraphQL */ `
	mutation RecordV4ReleaseMessageEvent($event: V4ReleaseMessageEvent!) {
		recordV4ReleaseMessageEvent(event: $event) {
			id
			v4ReleaseMessageSeenAt
			v4ReleaseMessageClosedAt
			v4ReleaseMessageLinkFollowedAt
		}
	}
`;

export const useClaimV4ReleaseMessage = () =>
	useMutation({
		mutationKey: ["claimV4ReleaseMessage"],
		mutationFn: () =>
			gqlReqNext<
				ClaimV4ReleaseMessageMutation,
				ClaimV4ReleaseMessageMutationVariables
			>({ query: claimMutation }),
		retry: 2,
	});

export const useRecordV4ReleaseMessageEvent = () =>
	useMutation({
		mutationKey: ["recordV4ReleaseMessageEvent"],
		mutationFn: (variables: RecordV4ReleaseMessageEventMutationVariables) =>
			gqlReqNext<
				RecordV4ReleaseMessageEventMutation,
				RecordV4ReleaseMessageEventMutationVariables
			>({ query: recordEventMutation, variables }),
		retry: 2,
	});
